import { graphql } from "gatsby";
import React from "react";

import { useSiteMetadata } from "../hooks/useSiteMetadata";
import ContentUtils from "../utils/ContentUtils";
import LinkUtils from "../utils/LinkUtils";
export function Head({ location, data }) {
	const siteMetadata = useSiteMetadata();
	const seoData = ContentUtils.getSeoMetadata(data);
	const seoMetadata = seoData ?? {};
	const seoMetaDescription = seoMetadata.seoDescription
		? seoMetadata.seoDescription.seoDescription
		: null;
	const socialDescription = seoMetadata.socialDescription
		? seoMetadata.socialDescription.socialDescription
		: null;

	const facebookImage = seoMetadata.facebookImage
		? LinkUtils.fixedProtocol(seoMetadata.facebookImage.gatsbyImageData.src)
		: null;
	const twitterImage = seoMetadata.twitterImage
		? LinkUtils.fixedProtocol(seoMetadata.twitterImage.gatsbyImageData.src)
		: null;
	const pageTitle = `${seoMetadata.seoTitle} | ${siteMetadata.title}`;
	const siteUrl = process.env.SITE_URL.substring(
		0,
		process.env.SITE_URL.length - 1
	);
	return (
		<>
			<html lang="en" />
			<meta charSet="utf-8" />
			<meta
				name="viewport"
				content="width=device-width, initial-scale=1, shrink-to-fit=no"
			/>
			<meta httpEquiv="x-ua-compatible" content="ie=edge" />
			<meta name="description" content={seoMetaDescription} />
			<meta property="og:title" content={seoMetadata.seoTitle} />
			<meta property="og:description" content={socialDescription} />
			<meta content="website" />
			<meta property="og:url" content={`${siteUrl}${location.pathname}`} />
			<meta property="og:site_name" content={siteMetadata.title} />
			<meta name="twitter:card" content="summary" />
			<meta name="twitter:creator" content={siteMetadata.author} />
			<meta name="twitter:title" content={seoMetadata.socialTitle} />
			<meta name="twitter:site" content={`${siteUrl}${location.pathname}`} />
			{twitterImage && <meta name="twitter:image" content={twitterImage} />}
			<meta name="twitter:description" content={socialDescription} />
			{facebookImage && (
				<>
					<meta property="og:image" content={facebookImage} />
					<meta property="og:image:width" content="1200" />
					<meta property="og:image:height" content="630" />
					<meta name="twitter:image" content="" />
				</>
			)}
			<meta name="theme-color" content="#034e11" />
			<title>{pageTitle}</title>
			<link rel="sitemap" type="application/xml" href="/sitemap-index.xml" />
			<link rel="icon" href="/favicon-32x32.png" type="image/png" />
			<link
				rel="manifest"
				href="/manifest.webmanifest"
				crossOrigin="anonymous"
			/>
			<link rel="apple-touch-icon" sizes="48x48" href="/icons/icon-48x48.png" />
			<link rel="apple-touch-icon" sizes="72x72" href="/icons/icon-72x72.png" />
			<link rel="apple-touch-icon" sizes="96x96" href="/icons/icon-96x96.png" />
			<link
				rel="apple-touch-icon"
				sizes="144x144"
				href="/icons/icon-144x144.png"
			/>
			<link
				rel="apple-touch-icon"
				sizes="192x192"
				href="/icons/icon-192x192.png"
			/>
			<link
				rel="apple-touch-icon"
				sizes="256x256"
				href="/icons/icon-256x256.png"
			/>
			<link
				rel="apple-touch-icon"
				sizes="384x384"
				href="/icons/icon-384x384.png"
			/>
			<link
				rel="apple-touch-icon"
				sizes="512x512"
				href="/icons/icon-512x512.png"
			/>
			<link
				rel="canonical"
				href={location.protocol + "//" + location.host + location.pathname}
				data-baseprotocol="https:"
				data-basehost={location.hostname}
			/>
			<link
				rel="preconnect"
				href="https://use.typekit.net/"
				crossOrigin="anonymous"
			/>
			<link
				rel="preload"
				as="style"
				href="https://use.typekit.net/qer0dqw.css"
			/>
		</>
	);
}

export const query = graphql`
	fragment SeoMetaDataInformation on ContentfulSeoMetadata {
		seoTitle
		seoDescription {
			seoDescription
		}
		socialDescription {
			socialDescription
		}
		socialTitle
		seoKeywords
		facebookImage: socialImage {
			gatsbyImageData(width: 1200, height: 630)
		}
		twitterImage: socialImage {
			gatsbyImageData(width: 260, height: 260)
		}
	}
`;
